const initialState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  nbResult: 0
};
export const workflowReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_WORKFLOW_LIST": {
      return initialState;
    }
    case "FETCH_WORKFLOW_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_WORKFLOW_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      // Ovoid duplicates
      const newItems = (data || []).filter(newItem => {
        return !state.items.find(item => item.id === newItem.id);
      });

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: state.items.concat(newItems),
        nbResult: nbResult
      };
    }
    case "FETCH_WORKFLOW_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/workflow.js